<script setup lang="ts" generic="T extends string">
import { computed, type PropType } from 'vue';
import { DropdownItem, DropdownMenu } from '../Dropdown';
import type { SelectMenuOrientationType } from './types/selectMenuOrientation.type';

const props = defineProps({
  bordered: { type: Boolean, default: false },
  options: { type: Array as PropType<T[]>, required: true },
  orientation: { type: String as PropType<SelectMenuOrientationType>, default: 'center' }
});

const roundedClx = computed(() => ({
  'border rounded-full border-default-very-light': props.bordered
}));

const contentOrientationClx = computed(() => ({
  'text-start': props.orientation === 'start',
  'text-center': props.orientation === 'center',
  'text-end': props.orientation === 'end'
}));

const modelValue = defineModel<T>({ required: true });

function onSelectDropdownItem(selection: T) {
  modelValue.value = selection;
}
</script>

<template>
  <div class="flex">
    <div :class="roundedClx" class="flex self-start">
      <DropdownMenu class="flex-1 basis-0 hover:bg-gray-50 rounded-full">
        <slot /> <strong class="max-w-36 truncate text-nowrap">{{ modelValue }}</strong>
        <template #items>
          <DropdownItem v-for="option in options" :key="option" @click="() => onSelectDropdownItem(option)">
            <div :class="contentOrientationClx" class="w-full px-2 hover:bg-gray-50">
              <span :class="option === modelValue ? 'font-bold' : ''">
                {{ option }}
              </span>
            </div>
          </DropdownItem>
        </template>
      </DropdownMenu>
    </div>
  </div>
</template>
